var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Users/tonybarsotti/Sites/hopkins/~/core-js/modules/_html.js
// module id = 49
// module chunks = 0